module.exports = __webpack_public_path__ + "img/services-icon4.65bf0837.png";